import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

const API_BASE = 'https://rbuymart.rbhardwaj.com/server/api/shipping';

export const triggerOrderManifest = createAsyncThunk(
    'shipping/triggerOrderManifest',
    async (orderId, { rejectWithValue }) => {
        try {
            const response = await fetch(`${API_BASE}/manifest.php`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('access_token')}`
                },
                body: JSON.stringify({ order_id: orderId })
            });

            const data = await response.json();
          
            if (!response.ok) return rejectWithValue(data.message);
            return data;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

const shippingSlice = createSlice({
    name: 'shipping',
    initialState: { dispatchLogs: null, operationsLoading: false, error: null },
    reducers: { clearShippingStateLog: (state) => { state.dispatchLogs = null; } },
    extraReducers: (builder) => {
        builder
            .addCase(triggerOrderManifest.pending, (state) => { state.operationsLoading = true; state.error = null; })
            .addCase(triggerOrderManifest.fulfilled, (state, action) => {
                state.operationsLoading = false;
                state.dispatchLogs = action.payload;
            })
            .addCase(triggerOrderManifest.rejected, (state, action) => {
                state.operationsLoading = false;
                state.error = action.payload;
            });
    }
});

export const { clearShippingStateLog } = shippingSlice.actions;
export default shippingSlice.reducer;